import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, Link } from "gatsby-plugin-intl";
import _noop from "lodash.noop";
import Button from "components/Button";
import { useServiceModalsContext } from "./context";

const ServiceModalContent = ({
  title,
  animatedBannerSrc,
  partnersSrc,
  onButtonClick = _noop,
}) => {
  const serviceModal = useServiceModalsContext();

  return (
    <div className="flex flex-col items-center pb-8">
      <div className="h-56">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          className="h-full"
          controls={false}
          loop
          autoPlay
          playsInline
          muted
        >
          <source src={animatedBannerSrc} type="video/mp4" />
        </video>
      </div>

      <h3 className="text-primary text-xl text-center mt-8">{title}</h3>

      <div className="w-4/6 mt-16 mb-16">
        <img className="w-full" src={partnersSrc} alt="banner" />
      </div>

      <div className="w-64">
        <Button
          className="w-full"
          variant="default"
          startIcon={<FontAwesomeIcon icon={faHome} />}
          component={Link}
          to="/#branches"
          onClick={e => {
            onButtonClick(e);
            serviceModal.closeModal();
          }}
        >
          <FormattedMessage id="branches.findBranch" />
        </Button>
      </div>
    </div>
  );
};

ServiceModalContent.propTypes = {
  title: PropTypes.string,
  animatedBannerSrc: PropTypes.string,
  partnersSrc: PropTypes.string,
  onButtonClick: PropTypes.func,
};

export default ServiceModalContent;
